import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Boothfee } from './boothfee.model';
import { BoothfeeService } from './boothfee.service';
@Injectable()
export class BoothfeePopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private boothfeeService: BoothfeeService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.boothfeeService.find(id).subscribe((boothfee) => {
                boothfee.validFrom = this.datePipe
                    .transform(boothfee.validFrom, 'yyyy-MM-ddThh:mm');
                boothfee.updated = this.datePipe
                    .transform(boothfee.updated, 'yyyy-MM-ddThh:mm');
                boothfee.created = this.datePipe
                    .transform(boothfee.created, 'yyyy-MM-ddThh:mm');
                this.boothfeeModalRef(component, boothfee);
            });
        } else {
            return this.boothfeeModalRef(component, new Boothfee());
        }
    }

    boothfeeModalRef(component: Component, boothfee: Boothfee): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.boothfee = boothfee;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/boothfee/boothfee-popup.service.ts